const selectors = {
  carousel: "[data-carousel]",
  slides: ".carousel__slide",
  carouselWraps: "carousel--columns-wrap-around",
  textBlock: ".text-block",
  nextButton: ".carousel__next-button",
  previousButton: ".carousel__previous-button",
  textBlock: ".text-block",
};

// carouslePosition denotes where the carousel lies within the container
// depending on if there is text content above or below. Carousel navigation
// paddles will be adjusted to the carousel.
const carousel = (node, { carouselPosition = "bottom" } = {}) => {
  let carousel = null;

  const { textPosition, textAlignment } = node.dataset;
  const carouselIsInline = textPosition === "middle";
  const carouselWraps = node.classList.contains(selectors.carouselWraps);

  const navPrevButton = node.querySelector(selectors.previousButton);
  const navNextButton = node.querySelector(selectors.nextButton);

  const carouselContainer = node.querySelector(selectors.carousel);
  const slides = node.querySelectorAll(selectors.slides);
  const textBlock = node.querySelector(selectors.textBlock);

  const _init = () => {
    import(flu.chunks.flickity).then(({ Flickity }) => {
      const carouselOpts = {
        adaptiveHeight: false,
        wrapAround: false,
        contain: true,
        cellAlign: "left",
        prevNextButtons: false,
        pageDots: false,
        initialIndex: 0,
        dragThreshold: 1,
      };

      // Only wrap around if there is enough content to wrap
      if (carouselWraps) {
        carouselOpts.wrapAround = true;
      } else if (!carouselWraps && textAlignment == "right") {
        carouselOpts.initialIndex = slides.length - 1;
        carouselOpts.cellAlign = "right";
      }

      carousel = new Flickity(carouselContainer, {
        ...carouselOpts,
        on: {
          ready: function () {
            _initNavigation();
          },
          scroll: progress => {
            if (carouselIsInline) {
              _updateTextBlock(progress);
            }

            if (!carouselWraps) {
              _updateNavigation(progress);
            }
          },
        },
      });

      carouselContainer.addEventListener(
        "dragStart",
        () => (document.ontouchmove = () => false)
      );
      carouselContainer.addEventListener(
        "dragEnd",
        () => (document.ontouchmove = () => true)
      );

      carousel.resize();

      setTimeout(() => {
        _updateNavigationPosition(carousel.size.height);
      }, 1000);
    });
  };

  const _updateTextBlock = progress => {
    if (!textBlock) return;

    const progressScale = progress * 100;
    if (textAlignment == "left") {
      textBlock.classList.toggle("out-of-view", progressScale > 1);
    } else if (textAlignment == "right") {
      textBlock.classList.toggle("out-of-view", progressScale < 99);
    }
  };

  const _updateNavigation = progress => {
    const progressScale = progress * 100;

    // Need to hide the prev/next navigation if progress meets thresholds
    // https://github.com/metafizzy/flickity/issues/289
    navPrevButton.disabled = progressScale < 1;
    navPrevButton.setAttribute("focusable", progressScale < 1 ? false : true);
    navNextButton.disabled = progressScale > 99;
    navNextButton.setAttribute("focusable", progressScale > 99 ? false : true);
  };

  const _initNavigation = () => {
    navPrevButton.addEventListener("click", _previousSlide);
    navNextButton.addEventListener("click", _nextSlide);

    if (!carouselWraps && textAlignment == "right") {
      navNextButton.disabled = true;
      navNextButton.setAttribute("focusable", false);
    } else if (!carouselWraps) {
      navPrevButton.disabled = true;
      navPrevButton.setAttribute("focusable", false);
    }
  };

  const _updateNavigationPosition = carouselHeight => {
    const buttonHeight = navNextButton.clientHeight;
    const containerPadding = parseFloat(
      window.getComputedStyle(node).getPropertyValue("padding-top")
    );
    const offset = carouselHeight / 2 - buttonHeight / 2 + containerPadding;

    navNextButton.style[carouselPosition] = `${offset}px`;
    navPrevButton.style[carouselPosition] = `${offset}px`;

    navNextButton.classList.remove("hidden");
    navPrevButton.classList.remove("hidden");
  };

  const _nextSlide = () => {
    carousel.next();
  };

  const _previousSlide = () => {
    carousel.previous();
  };

  _init();

  const unload = () => {
    carousel.destroy();
    navPrevButton.removeEventListener("click", _previousSlide);
    navNextButton.removeEventListener("click", _nextSlide);
  };

  const goToSlide = index => {
    carousel.select(index);
  };

  return { unload, goToSlide };
};

export default carousel;
